<template>
	<div id="Recharge">
	<mt-header :title="title" fixed>
	   <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
	   </a>
	</mt-header>
	<div class="mt40">
 	 <div>
 	    <mt-field label="商品类型"  v-model="value"  disabled class="border-bottom-line"></mt-field>
 	 </div>
 	</div>
 	<div class="border-bottom-line">
       <mt-field label="优酷账号" placeholder="请输入注册优酷的手机号" type="tel" v-model="account" :attr="{ maxlength: 11 }"></mt-field>
    </div>
    <div class="border-bottom-line">
        <mt-field label="确认优酷账号" placeholder="请确认注册优酷的手机号" type="tel" v-model="requireAccount" :attr="{ maxlength: 11 }"></mt-field>
    </div>
 	<div class="bgcontent border-bottom-line">
 	  <div class="faceValueBox">
 	  	<ul class="faceValue">
 	 	 <li v-for="(item,index) in parvalue" :class="{mr0:(index+1) % 3==0,active:currentIndex==index}" @click="payType(index)">
 	 	 	<p class="font-size9">{{item.proName}}</p>
 	 	 </li>
 	 	</ul>
 	  </div>
 	</div>
 	<div class="bgcontent">
 	   <dl class="purchase">
 	   	 <dt>
 	   	 	<p class="colorff8900 font-size10" v-show="price!=''"><strong>{{price}}元</strong></p>
 	   	 </dt>
 	   	 <dd><mt-button :disabled="disabled" type="primary" size="small" class="font-Yahei btnbuy" @click="btnBuy" v-show="paysType!=''">{{type==2?'立即充值':'立即购买'}}</mt-button></dd>
 	   </dl>
 	</div>
 	<div class="bgcontent">
 		<div class="dec">
 			<p class="mb5" v-if="game!=null">商品适用游戏：{{game}}</p>
 			<div  v-html="dec"></div>
 		</div>		
 	</div>
 	</div>
</template>

<script>
	import { Toast } from 'mint-ui'
	import { Indicator } from 'mint-ui'
	export default{
		data(){
			return{
			   value:"",
			   type: "",
			   num:"1",
			   account:"",//优酷账号
			   requireAccount:"",//确定账号
			   urltid:this.$route.query.tid,//后台配置的跳转
			   tid:localStorage.getItem("tid"), //二级分类ID
			   ttype:localStorage.getItem("ttype"),//商品分类 (1-卡密,2-直充,0-实物) 默认为-1
			   faceId:localStorage.getItem("faceId"),
			   options:[],
			   parvalue:[],
			   price:"",
			   currentIndex:"",
			   dec:"",
			   game:"",//适用游戏
			   url:"",
			   title:"",   
			   paysType:[],
			   proName:"",
			   pic:"",
			   pid:"",
			   disabled:false
			}
		},
		created:function(){
			this.showType();			
	    },
	    methods: {
	     returnBack(){
	       	 this.$router.go(-1);
	     },
	     //2.8商品详情接口
    	 showType(){
    	 	Indicator.open();
    	 	if(this.urltid!=undefined){
    	 		this.tid = this.urltid;
    	 		this.ttype = 2;
    	 	}
	      	this.$http.post(this.URL_PREFIX+"/category/findCategoryTypeById.net",{tid:this.tid,proType:this.ttype})
		  	.then((res) =>{
		  	  //console.log(res);
		  	  Indicator.close();
		  	  this.value=res.data.obj.proType[0].label;
		  	  this.type=res.data.obj.proType[0].value;
		  	  this.url=res.data.obj.url;
		  	  this.showInfo();
		   });     
	     },
	     showInfo(){   
	     	this.$http.post(this.URL_PREFIX+"/category/findCategoryTypeById.net",{tid:this.tid,proType:this.type})
		  	.then((res) =>{
		  		  this.parvalue=res.data.obj.products;
		  		  if(res.data.obj.products==undefined){
		  		  	this.disabled=true;
		  		  }else{
		  		  	this.disabled=false;
		  		  }
//		  		  console.log('打印卡密信息');
//		  		  console.log(res.data.obj.products)
		  		  this.title=res.data.obj.tName;
		  		  this.dec=res.data.obj.proIntroduce;
		  		  this.game=res.data.obj.game;
		  		  var faceId=this.faceId;
		  		  var faceIdi;
		  		  if(faceId!=null){
			  		  this.parvalue.forEach(function(item,i){
			  		  	if(item.id==faceId){
			  		  	    faceIdi=i;
			  		  		return;
			  		  	}
					      
				      });
				      this.payType(faceIdi); 
				      this.faceId=null;
			     }else if(res.data.obj.products!=undefined){
			       this.payType(0); 
			     }
		   });
	     },
	     payType(i){  
	     	this.currentIndex=i;
	     	this.price=this.parvalue[i].price; //获取价格
	     	this.paysType=this.parvalue[i].payType;//获取支付方式
	     	this.proName=this.parvalue[i].proName;//获取面值名称
	     	this.pid=this.parvalue[i].pid;//商品pid
	     	if(this.parvalue[i].pics!=null){
	     	  this.pic=this.parvalue[i].pics.file;//获取面值图片
	     	}
	     	
	     },
	     //点击立即购买按钮
	     btnBuy(){
	     	localStorage.setItem("price",this.price);
	     	localStorage.setItem("proName",this.proName);
	     	localStorage.setItem("type",this.type);
	     	localStorage.setItem("pic",this.pic);
	     	localStorage.setItem("tName",this.title);
	     	localStorage.setItem("pid",this.pid);
	     	var obj=JSON.stringify(this.paysType);
	     	localStorage.setItem("payType",obj);
	     	localStorage.setItem("num","");//数量
	     	localStorage.setItem("totalPrice","");//总金额
	     	localStorage.setItem("account","");
     	    if(this.validateNetEase()){
     	   	 localStorage.setItem("account",this.account);
     	   	 this.$router.push({path: '/Order/index'});
     	    }
	     },
     	//优酷账号验证
       validateNetEase(){
         var reg=/^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
       	 if(this.account==''){
            Toast("请输入优酷账号");
            return false;
        }else if(!reg.test(this.account)){
       	   	  Toast("优酷账号输入不正确");
              return false;
     	}else if(this.requireAccount==''){
        	Toast("请确认优酷账号");
            return false;
        }else if(!reg.test(this.requireAccount)){
       	   	  Toast("确认优酷账号输入不正确");
              return false;
     	}else if(this.account!==this.requireAccount){
            Toast("两次账号输入不一致");
            return false;
        }else{
          return true;
        }
     	}
	  }
	}
</script>  

<style scoped="scoped">
.faceValueBox{width: 95%;margin: 0 auto;padding: 15px 0 5px 0;overflow: hidden;}
.faceValue li{float: left; border:1px solid #ff8900; color: #ff8900;border-radius: 5px;-webkit-border-radius: 5px;width: 30%;margin: 0 4% 4% 0;display: -webkit-flex;display:flex;-webkit-align-items: center;align-items: center;-webkit-justify-content: center;justify-content: center;height: 60px;text-align: center;}
.faceValue li.mr0{margin-right: 0;}
.faceValue li.active{background: #ff8920;color: #fff;border:1px solid #ff8920;}
.faceValue li p.element{color: #ff5513;}
.faceValue li.active p.element{color: #fff;}
.numtip{color: red;font-size: 0.7rem;margin-left: 10px;}
.purchase{padding: 20px 15px;border-bottom: 1px solid #e0e0e0;overflow: hidden;}
.purchase dt{width: 65%;float: left;line-height: 23px;margin-top: 6px;}
.purchase dd{float: right;/*margin-top: 3%;*/}
.purchase dd button{line-height: 36px;}
.dec{width: 92%;margin: 0 auto;color: #999;font-size: 0.8rem;padding: 10px 0 20px 0;line-height: 20px;}
</style>


// WEBPACK FOOTER //
// src/views/Details/Recharge.vue